import React from "react";

import { Box, Grid, Typography } from "@mui/material";
import { FormProvider, useFieldArray, useFormContext } from "react-hook-form";

import OverrideDatePanel from "../components/OverrideDatePanel";
import ScheduleListItem from "../components/ScheduleListItem";
import { FormValues, WdayRule } from "../SchedulerPage";

type Props = {
  onRemoveInterval: (interval: WdayRule["intervals"][0]) => Promise<void>;
};

const ScheduleListView: React.FC<Props> = ({ onRemoveInterval }) => {
  const formMethods = useFormContext<FormValues>();
  const { control, getValues } = formMethods;
  const { append, update } = useFieldArray({
    control,
    name: `dateRules`,
  });

  const wdayDates: WdayRule[] = getValues("wdayRules");

  function handleRemoveOverride(overrideIndex: number) {
    //nullify the override's intervals if it's removed
    //to clear all the validation errors if there's any.
    const nullifiedIntervals = getValues(
      `dateRules.${overrideIndex}`
    ).intervals.map((e) => {
      return {
        startTime: null,
        endTime: null,
        _destroy: true,
      };
    });
    const overrideToRemove = getValues(`dateRules.${overrideIndex}`);
    overrideToRemove.intervals = nullifiedIntervals;
    update(overrideIndex, { ...overrideToRemove, _destroy: true });
  }
  return (
    <Box sx={{ flexGrow: 1, paddingTop: 4 }}>
      <FormProvider {...formMethods}>
        <Grid container spacing={3}>
          <Grid item xs={8} md={8}>
            <Box
              sx={{ backgroundColor: "#fff" }}
              display="flex"
              flexDirection="column"
              alignItems="center"
              padding={4}
            >
              <div
                style={{
                  display: "block",
                  alignSelf: "start",
                  marginBottom: 21,
                }}
              >
                <Typography variant="body1" fontWeight="700">
                  Set your weekly hours
                </Typography>
              </div>
              {wdayDates.map((rule, index: number) => (
                <ScheduleListItem
                  key={index}
                  wday={rule.wday}
                  ruleIndex={index}
                  onRemoveInterval={onRemoveInterval}
                />
              ))}
            </Box>
          </Grid>
          <Grid item xs={4} md={4}>
            <Box
              sx={{ backgroundColor: "#fff", height: "100%", padding: 4 }}
              display="flex"
              flexDirection="column"
              alignItems="center"
            >
              <OverrideDatePanel onRemove={handleRemoveOverride} />
            </Box>
          </Grid>
        </Grid>
      </FormProvider>
    </Box>
  );
};

export default ScheduleListView;
